import { Link } from "react-router-dom";
import { Instagram, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-32 border-t border-black/5 bg-[#F0EBE1]/50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="italic-serif text-4xl md:text-5xl leading-[1.05] text-espresso">
            Some people love well.<br />
            <span className="text-[#4A7C7B]">Others love differently.</span>
          </div>
          <p className="mt-6 max-w-md text-sm text-charcoal/90 leading-relaxed">
            A picture-book series written to sit with children through hard chapters — parental absence, complicated grown-ups, and the quiet inner voice that helps them find their footing. Made for parents, teachers, and counselors who want kinder language and steadier hands on the tender days.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="mono text-[11px] uppercase tracking-[0.24em] text-[#4A7C7B] mb-4">Site</div>
          <ul className="space-y-2 text-sm text-espresso/85">
            <li><Link to="/" className="link-draw">Home</Link></li>
            <li><Link to="/charlie" className="link-draw">Meet Charlie</Link></li>
            <li><Link to="/books" className="link-draw">The Book</Link></li>
            <li><Link to="/parents" className="link-draw">For Parents & Educators</Link></li>
            <li><Link to="/waitlist" className="link-draw">Waitlist</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="mono text-[11px] uppercase tracking-[0.24em] text-[#4A7C7B] mb-4">Follow along</div>
          <div className="flex items-center gap-3">
            <a
              data-testid="footer-instagram"
              href="https://www.instagram.com/"
              target="_blank" rel="noreferrer"
              className="w-11 h-11 grid place-items-center rounded-full border border-black/10 hover:bg-[#2C241B] hover:text-[#FAF8F5] transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </a>
            <a
              data-testid="footer-twitter"
              href="https://x.com/"
              target="_blank" rel="noreferrer"
              className="w-11 h-11 grid place-items-center rounded-full border border-black/10 hover:bg-[#2C241B] hover:text-[#FAF8F5] transition-colors"
              aria-label="X"
            >
              <Twitter size={18} />
            </a>
          </div>
          <p className="mt-10 text-xs text-charcoal/70">
            © {new Date().getFullYear()} The Love Well Project. Illustrations by Zuzana Svobodová. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
